import React from 'react';
import NoteCanvas from '@component/moashelf/note/note-canvas';

const NotePage: React.FC = () => <NoteCanvas />;

export default NotePage;
